import { useQuery } from 'react-query';

import { useFolderTypologyState } from '@/features/shared/hooks';
import { axios } from '@/lib/axios';

type GetFolderStatusAndItsTypologyResponse = {
  isFolder: boolean;
  direction: string;
  folderTypologyId: string;
};

const getFolderStatusAndItsTypologyAsync = ({ folderId }: { folderId: string }) =>
  axios.get<GetFolderStatusAndItsTypologyResponse>(`/folder-radixes/${folderId}`);

export const useGetFolderStatusAndItsTypologyAsync = ({ folderId }: { folderId: string }) =>
  useQuery({
    retry: 3,
    cacheTime: 0,
    queryKey: ['folder-radixes', folderId],
    queryFn: async () => {
      const { data } = await getFolderStatusAndItsTypologyAsync({ folderId });
      return data;
    },
    onSuccess: ({ folderTypologyId, isFolder, direction }) => {
      useFolderTypologyState.setState({ folderTypologyId, isFolder, direction });
    },
  });
